export function getFilenameExtension(filename) {
    return filename.split('.').pop();
}
export function getFilenameWithoutExtension(filename) {
    const fileExt = getFilenameExtension(filename);
    const regex = new RegExp(`.${fileExt}$`);
    return filename.replace(regex, '');
}
export default getFilenameExtension;
